import React from 'react';
import { GraduationCap, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img
                src={`${process.env.PUBLIC_URL}/priedu_logo.png`}
                alt="PriEdu Logo"
                className="h-14 w-auto rounded-lg"
              />
              <span className="text-xl font-bold text-white">PriEdu</span>
            </div>
            <p className="text-sm text-gray-400">
              Connecting students with verified, qualified home tutors for personalized learning experiences.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors duration-200">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors duration-200">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors duration-200">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors duration-200">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <a href="#features" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  Features
                </a>
              </li>
              <li>
                <a href="#tutors" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  Find Tutors
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  How It Works
                </a>
              </li>
              <li>
                <Link to="/tutor/register" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  Become a Tutor
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/help-center" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-sm hover:text-blue-500 transition-colors duration-200">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-blue-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">support@priedu.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-blue-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">+91 94555 45273</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-blue-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">Lucknow, Uttar Pradesh, India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} PriEdu. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;